<div class="row">
  <div class="col-sm-9" *ngIf="role == 'admin'">
    <h2>Door Status Graph({{storeData}} Stores)</h2>
  </div>
  <div class="col-sm-9" *ngIf="role == 'manager'">
    <h2>Door Status Graph({{ManagerStoreData?.length}} Stores)</h2>
  </div>


  <!-- <div class="col-sm-3">
    <input style="float: right; background-color: white; " type="text" placeholder="Search Store" nbInput
      [(ngModel)]="word" (keyup)="onFilterKeySearch()" />
  </div> -->
  <div class="col-sm-3 ">
    <div class="input-container">
      <input [nbDatepicker]="rangepicker" nbInput [(ngModel)]="date" placeholder="Search Date" autocomplete="off" />
      <button *ngIf="this.endDate" class="delete-button" type="reset" (click)="clearDate()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <nb-rangepicker #rangepicker (rangeChange)="updateRangeDate($event)" format="yyyy-MM-DD"></nb-rangepicker>
  </div>
</div>
<!-- <div class="row" *ngIf="role == 'admin'">
  <div class="col-sm-9 mt-3">
    <h5>Store Counts:{{storeData}}</h5>
  </div>
</div>
<div class="row" *ngIf="role == 'manager'">
  <div class="col-sm-9 mt-3">
    <h5>Store Counts:{{ManagerStoreData?.length}}</h5>
  </div>
</div> -->
<div id="chart" style="margin-top: 2vh;">
  <div *ngIf="displayChart">
    <div style="display: block;">
      <canvas baseChart
        [data]="lineChartData"
        [options]="lineChartOptions"
        [type]="lineChartType">
      </canvas>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>